export default "__VITE_ASSET__DQVZy1U0__"